export const PROMPTS = [
  "What made you smile today?",
  "What are three things you're grateful for right now?",
  "What's been on your mind lately?",
  "Describe a small moment from today you'd like to remember.",
  "What did you learn about yourself this week?",
  "What's something you're looking forward to?",
  "How are you really feeling today, and why?",
  "What would make tomorrow a good day?",
  "Who made a difference to your day, and how?",
  "What's one thing you'd like to let go of?",
  "Write about a place where you feel completely at home.",
  "What's a challenge you handled well recently?",
  "What does your ideal slow morning look like?",
  "What's a worry you can set down for tonight?",
  "Write a kind note to your future self.",
  "What's something you did today just for you?",
  "Which part of your home brings you the most calm?",
  "What's a recent win, big or small?",
  "What are you proud of this month?",
  "If today had a title, what would it be?",
  "What's a habit you'd love to grow?",
  "What did your body need today?",
  "Describe a memory that always makes you laugh.",
  "What's something beautiful you noticed recently?",
  "What would you tell a friend who felt the way you do today?",
  "What does balance mean to you right now?",
  "What are you curious about lately?",
  "What's one thing you can forgive yourself for?",
  "Write about a person you're thankful to have in your life.",
  "What gave you energy today, and what drained it?",
];

export const randomPrompt = (current) => {
  const pool = PROMPTS.filter((p) => p !== current);
  return pool[Math.floor(Math.random() * pool.length)];
};
